import { IDocumentImageSource } from "../../document";

export class SignExecuteResult {
  isComplete: boolean;
  imageSource: IDocumentImageSource;
  signatureCacheGuid: string;
}
